import React from "react";
import { useTranslation } from "react-i18next";

// Aviso "Hoy no hay eventos" (pantalla 01-B): icono calendario + texto, role="status".
export const NoTodayNotice = ({ nextText }) => {
  const { t } = useTranslation();
  return (
    <div className="ag-notice" role="status">
      <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
        <rect x="3" y="5" width="18" height="16" rx="2" />
        <line x1="3" y1="10" x2="21" y2="10" />
        <line x1="8" y1="3" x2="8" y2="7" />
        <line x1="16" y1="3" x2="16" y2="7" />
      </svg>
      <span>
        <b>{t("agenda.noTodayTitle")}</b> {nextText}
      </span>
    </div>
  );
};

// Estado vacío (pantalla 06). Con filtros: "No hay eventos con estos filtros" + "Ver toda la
// agenda" (quita los filtros). Sin filtros (tenant sin agenda): "No hay eventos programados",
// sin botón.
// Supuesto: el texto de apoyo ("Prueba con otro día o con más deportes.") solo aparece con filtros;
// sin filtros no hay nada que el usuario pueda probar.
export const AgendaEmpty = ({ filtered, onClear }) => {
  const { t } = useTranslation();
  return (
    <div className="ag-empty">
      <span className="ag-empty-title">{filtered ? t("agenda.emptyFilteredTitle") : t("agenda.emptyTitle")}</span>
      {filtered && <span className="ag-empty-text">{t("agenda.emptyFilteredText")}</span>}
      {filtered && (
        <button type="button" className="ag-outline-button" onClick={onClear}>
          {t("agenda.emptyFilteredButton")}
        </button>
      )}
    </div>
  );
};

// "‹ Volver a todas las fechas" (pantallas 03/13).
export const BackToDates = ({ onBack }) => {
  const { t } = useTranslation();
  return (
    <div className="ag-back">
      <button type="button" className="ag-link-button" onClick={onBack}>
        <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true">
          <polyline points="15 5 8 12 15 19" />
        </svg>
        {t("agenda.backToAllDates")}
      </button>
    </div>
  );
};
